function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
var Handler = /*#__PURE__*/function (_StateHandler) {
  function Handler(instance) {
    var _this;
    _classCallCheck(this, Handler);
    _this = _callSuper(this, Handler);
    _this.instance = instance;
    _this.sandbox = instance.getSandbox();
    _this.setState({
      styles: [],
      // layer related styles
      loading: false
    });
    _this.service = _this.instance.getService();
    _this.bindEvents();
    return _this;
  }
  _inherits(Handler, _StateHandler);
  return _createClass(Handler, [{
    key: "getName",
    value: function getName() {
      return 'UserStyleHandler';
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;
      this.service.on('update', function () {
        return _this2.updateStyleList();
      });
      this.service.on('ajax', function (loading) {
        return _this2.updateState({
          loading: loading
        });
      });
      this.sandbox.registerForEventByName(this, 'MapLayerEvent');
    }

    // listens MapLayerEvent only
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      // update style list on add layers (on startup)
      if (event.getOperation() === 'add' && !event.getLayerId()) {
        this.updateStyleList();
      }
    }
  }, {
    key: "updateStyleList",
    value: function updateStyleList() {
      var _this3 = this;
      var stylesByLayerId = {};
      this.service.getStyles().forEach(function (style) {
        var layerId = style.layerId;
        var added = stylesByLayerId[layerId];
        if (!added) {
          var layer = _this3.sandbox.findMapLayerFromAllAvailable(layerId);
          stylesByLayerId[layerId] = _objectSpread({
            layer: layer === null || layer === void 0 ? void 0 : layer.getName()
          }, style);
          return;
        }
        // layer has more than one style
        if (added.count) {
          added.count = added.count + 1;
        } else {
          // store only common values for style collection
          stylesByLayerId[layerId] = {
            layerId: added.layerId,
            layer: added.layer,
            count: 2
          };
        }
      });
      this.updateState({
        styles: Object.values(stylesByLayerId),
        loading: false
      });
    }
  }, {
    key: "deleteStyle",
    value: function deleteStyle(id) {
      this.service.removeUserStyle(id);
    }
  }, {
    key: "showStyleEditor",
    value: function showStyleEditor(id) {
      this.sandbox.postRequestByName('ShowUserStylesRequest', [{
        id: id
      }]);
    }
  }, {
    key: "addLayerToMap",
    value: function addLayerToMap(layerId, styleId) {
      var styleName = styleId === null || styleId === void 0 ? void 0 : styleId.toString();
      if (this.sandbox.isLayerAlreadySelected(layerId)) {
        if (styleName) {
          // use request to trigger event
          this.sandbox.postRequestByName('ChangeMapLayerStyleRequest', [layerId, styleName]);
        }
        return;
      }
      if (styleName) {
        var _this$sandbox$findMap;
        // AddMapLayerRequest is asynchoronous so style has to be selected before request
        // ChangeMapLayerStyleRequest doesn't work properly as layer isn't selected immediately
        (_this$sandbox$findMap = this.sandbox.findMapLayerFromAllAvailable(layerId)) === null || _this$sandbox$findMap === void 0 || _this$sandbox$findMap.selectStyle(styleName);
      }
      this.sandbox.postRequestByName('AddMapLayerRequest', [layerId]);
    }
  }, {
    key: "showLayerStyles",
    value: function showLayerStyles(layerId) {
      this.sandbox.postRequestByName('ShowUserStylesRequest', [{
        layerId: layerId
      }]);
    }
  }]);
}(StateHandler);
export var UserStyleHandler = controllerMixin(Handler, ['deleteStyle', 'showStyleEditor', 'addLayerToMap', 'showLayerStyles']);